document.querySelectorAll('.snscon-caption-btn').forEach(function(btn) {
  btn.addEventListener('click', function() {
    var wrapper = this.closest('.snscon-slide-txt-wrapper');
    var caption = wrapper.querySelector('.snscon-caption');

    caption.classList.toggle('hide');

    if (this.textContent.trim() === 'Read More') {
      this.textContent = 'Hide';
    } else {
      this.textContent = 'Read More';
    }
  });
});